import { useState } from "react";
import { MessageCircle, Send } from "lucide-react";
import { allCities, services } from "@/lib/siteData";
import { buildWhatsAppUrl } from "@/hooks/useWhatsAppMessage";

const initialForm = { name: "", phone: "", city: "Londrina", service: "Hidrojateamento", message: "" };

export const ContactForm = () => {
  const [form, setForm] = useState(initialForm);

  const update = (field) => (event) => setForm((current) => ({ ...current, [field]: event.target.value }));

  const submit = (event) => {
    event.preventDefault();
    window.open(buildWhatsAppUrl(form), "_blank", "noopener,noreferrer");
  };

  return (
    <form className="quote-form" onSubmit={submit} data-testid="whatsapp-quote-form">
      <div className="form-head" data-testid="quote-form-heading">
        <MessageCircle size={22} aria-hidden="true" />
        <span>Orçamento direto pelo WhatsApp</span>
      </div>

      <label data-testid="quote-name-label">
        Nome
        <input value={form.name} onChange={update("name")} placeholder="Seu nome" data-testid="quote-name-input" />
      </label>
      <label data-testid="quote-phone-label">
        Telefone
        <input value={form.phone} onChange={update("phone")} placeholder="(43) 99999-9999" data-testid="quote-phone-input" />
      </label>
      <label data-testid="quote-city-label">
        Cidade
        <select value={form.city} onChange={update("city")} data-testid="quote-city-select">
          {allCities.filter((city) => city !== "Norte do Paraná").map((city) => (
            <option key={city} value={city}>{city}</option>
          ))}
        </select>
      </label>
      <label data-testid="quote-service-label">
        Serviço
        <select value={form.service} onChange={update("service")} data-testid="quote-service-select">
          {services.map((service) => (
            <option key={service.slug} value={service.name}>{service.name}</option>
          ))}
        </select>
      </label>
      <label className="span-two" data-testid="quote-message-label">
        Mensagem
        <textarea value={form.message} onChange={update("message")} placeholder="Descreva o problema, urgência ou endereço aproximado." data-testid="quote-message-textarea" />
      </label>
      <button className="primary-action span-two" type="submit" data-testid="quote-whatsapp-submit-button">
        <Send size={18} aria-hidden="true" /> Enviar mensagem formatada
      </button>
    </form>
  );
};